import { render, staticRenderFns } from "./productCarousel.vue?vue&type=template&id=0fd35054&scoped=true&"
import script from "./productCarousel.vue?vue&type=script&lang=js&"
export * from "./productCarousel.vue?vue&type=script&lang=js&"
import style0 from "./productCarousel.vue?vue&type=style&index=0&id=0fd35054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd35054",
  null
  
)

export default component.exports